import { safeTextInsert } from 'utils/formatters';
import { removeLogInDataFromBrowser } from 'utils/localStoreTools';

export const signInActions = {
  google: (redirect?: string) => {
    removeLogInDataFromBrowser();
    window.location.replace(`${process.env.NEXT_PUBLIC_API_HOST}/oauth/google${safeTextInsert(redirect, '?')}`);
  },
  facebook: (redirect?: string) => {
    removeLogInDataFromBrowser();
    window.location.replace(`${process.env.NEXT_PUBLIC_API_HOST}/oauth/facebook${safeTextInsert(redirect, '?')}`);
  },
  apple: (redirect?: string) => {
    removeLogInDataFromBrowser();
    window.location.replace(`${process.env.NEXT_PUBLIC_API_HOST}/oauth/apple${safeTextInsert(redirect, '?')}`);
  },
};

export const signUpActions = {
  google: (redirect?: string) => {
    removeLogInDataFromBrowser();
    window.location.replace(`${process.env.NEXT_PUBLIC_API_HOST}/oauth/google${safeTextInsert(redirect, '?')}`);
  },
  facebook: (redirect?: string) => {
    removeLogInDataFromBrowser();
    window.location.replace(`${process.env.NEXT_PUBLIC_API_HOST}/oauth/facebook${safeTextInsert(redirect, '?')}`);
  },
  apple: (redirect?: string) => {
    removeLogInDataFromBrowser();
    window.location.replace(`${process.env.NEXT_PUBLIC_API_HOST}/oauth/apple${safeTextInsert(redirect, '?')}`);
  },
};
